import __decorate from "../_virtual/_@oxc-project_runtime@0.147.0/helpers/esm/decorate.js";
import { PdDefaultWizardStep } from "../pd-default-wizard-step/PdDefaultWizardStep.js";
import { html } from "lit";
import { property } from "lit/decorators.js";
import "@progressive-development/pd-order/pd-order-contacts";
//#region src/default-step-address/DefaultStepAddress.ts
/**
* DefaultStepAddress - Abstract base class for address/contact wizard steps
*
* Provides integration with pd-order-contacts component for collecting
* customer contact information in wizard flows.
*
* @example
* ```typescript
* interface OrderFormData {
*   // ... your order data
*   contacts?: PdOrderContactData;
* }
*
* @customElement("my-address-step")
* export class MyAddressStep extends DefaultStepAddress<OrderFormData> {
*   _addressInfo = "Please enter your contact details.";
*
*   reloadFromOrder(order: OrderFormData) {
*     this.contacts = order.contacts;
*   }
* }
* ```
*/
/**
* Abstract base class for address wizard steps.
*
* @typeParam T - The complete order/wizard form data type
*/
var DefaultStepAddress = class extends PdDefaultWizardStep {
	constructor(..._args) {
		super(..._args);
		this.withPayment = false;
		this.withPropertyOwner = false;
		this.withPropertyDate = false;
		this.requiredFields = [];
	}
	render() {
		return this._renderFormContent();
	}
	_renderFormContent() {
		return html`
      ${this._addressInfo ? html`<p>${this._addressInfo}</p>` : ""}
      <pd-order-contacts
        id="stepFormContainerId"
        ?withPayment="${this.withPayment}"
        ?withPropertyOwner="${this.withPropertyOwner}"
        ?withPropertyDate="${this.withPropertyDate}"
        .match="${this.match}"
        .orderContact="${this.contacts?.orderContact}"
        .billingContact="${this.contacts?.billingContact}"
        .adminContact="${this.contacts?.adminContact}"
        .propertyContact="${this.contacts?.propertyContact}"
        .requiredFields="${this.requiredFields}"
      ></pd-order-contacts>
    `;
	}
};
__decorate([property({ type: Object })], DefaultStepAddress.prototype, "match", void 0);
__decorate([property({ type: Object })], DefaultStepAddress.prototype, "contacts", void 0);
__decorate([property({ type: Boolean })], DefaultStepAddress.prototype, "withPayment", void 0);
__decorate([property({ type: Boolean })], DefaultStepAddress.prototype, "withPropertyOwner", void 0);
__decorate([property({ type: Boolean })], DefaultStepAddress.prototype, "withPropertyDate", void 0);
__decorate([property({ type: Array })], DefaultStepAddress.prototype, "requiredFields", void 0);
//#endregion
export { DefaultStepAddress };
